import React, { useState } from 'react';
import Toast from 'react-native-toast-message';
import { dispatchService } from '../../../services/central-api/dispatch';
import { openExternalLinkInNewTab } from '../../../services/navigation-assistant';
import { ClientError } from '../../../services/central-api/base-service';
import { translate } from '../../../services/translate';
import CustomButton from '../../../components/CustomButton';

interface Props {
    report?: SignableReport;
}

export default function ExportRasRdpPDFDetails({ report }: Props) {
    const [loading, setIsLoading] = useState(false);

    async function downloadPdf() {
        if (!report) {
            return;
        }
        try {
            setIsLoading(true);
            const signableReport = await dispatchService.getSignableReport(report.id);
            openExternalLinkInNewTab(signableReport.resultUrl);
        } catch (err) {
            if (err instanceof ClientError) {
                return Toast.show({
                    type: 'sentinelxError',
                    text1: translate(err.message),
                });
            }

            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <CustomButton
            text={translate('downloadRasRdpReport')}
            onPress={() => downloadPdf()}
            style={{ minWidth: 158 }}
            type='secondary'
            isLoading={loading}
        />
    );
}
